import { z } from "zod/v4";

import { ExperienceListWithOffersDto } from "../../../dtos/experiences-list";

export const GetOffersExperienceListResponseSchema = z.object({
  experiencesList: ExperienceListWithOffersDto.array(),
});

export type GetOffersExperienceListResponseType = z.infer<
  typeof GetOffersExperienceListResponseSchema
>;
